// extracted by mini-css-extract-plugin
export default {"UpDownCounter":"UpDownCounter_UpDownCounter__WbqaH","TextInput":"UpDownCounter_TextInput__1RVI2"};